import CesiumManagerWrapper from "./CesiumManagerWrapper";
import Abstract3DMapHandler from "./Abstract3DMapHandler";
import ConfirmationModal from "../../common/ConfirmationModal";
import PointsConverter from "./PointsConverter"

export default class ExternalTrackMap3DHandler extends Abstract3DMapHandler {

    constructor(first_appear_ad = 100, frequency_ad = 100) {
        super(first_appear_ad, frequency_ad);
        
        this.loaded_counter = 0;
        this.lastAddedPoints = {};
        this.socket_points = {};
        this.players = {};
        this.cesium_started = false;
        
        this.sceneActivityIcon = null;

        this.scene_type = "other";
    }

    start_timer() {
        super.start_timer("replay_map");
    }

    async init(data) {
        this.tracks = data.session.tracks;
        this.scene_type = data.scene_type;
        this.track_ids = data.track_ids;
        this.host = data.host;
        
        this.related_tracks = data.related_tracks;

        $("#loading_track_modal").modal({
            backdrop: 'static',
            keyboard: false
        });
        await this.loadTracks();
    }
    async loadTracks(related = false) {     
        const loading = this.tracks.map((x,i) => this.getTrack(x,i));
        await Promise.all(loading);
        
        await this.getAlongRoute(this.tracks[0].id);
        await this.startCesium();
    }

    async startCesium() {
        var userData = [];
        for (var i = 0; i < this.tracks.length; i++) {
            const track = this.tracks[i];
            const rawPointsData = this.points[i];

            const player = {
                tid: this.tracks[i].id,
                uid: this.tracks[i].user.id,
                uname: this.tracks[i].user.user_name,
                color: this.tracks[i].user.color,
                altitude_offset: 0,
                cesium_ready: true
            }

            // Set the player.point_id based on the last point's track_point_id
            if (rawPointsData && rawPointsData.points_header && rawPointsData.points.length > 0) {
                const track_point_id_header = rawPointsData.points_header.findIndex(header => header === "track_point_id");
                if (track_point_id_header !== -1) {
                    player.point_id = rawPointsData.points[rawPointsData.points.length - 1][track_point_id_header];
                } else {
                    player.point_id = rawPointsData.points.length - 1;
                }
            } else {
                player.point_id = 0;
            }

            this.players[this.tracks[i].user.user_name] = player;

            var userTrackData = {
                userId: this.tracks[i].user.id,
                userName: this.tracks[i].user.user_name,
                profileUrl: this.tracks[i].user.user_url,
                avatarUrl: this.tracks[i].user.profile_picture_url,
                track: {
                    id: this.tracks[i].id,
                    group_id: this.tracks[i].group_id,
                    color: this.tracks[i].user.color,
                    maxAltitude: this.tracks[i].max_altitude,
                    started_at: this.tracks[i].started_at,
                    finished_at: this.tracks[i].finished_at,
                    created_at: this.tracks[i].created_at,
                    activity_icon: this.tracks[i].activity_icon,
                    time_zone: this.tracks[i].time_zone,
                    raw_points_data: this.points[i]
                },
            }
            if (i == 0) {
                userTrackData["isDefault"] = true;
            }
            userData.push(userTrackData);
        }

        if (this.tracks.length > 0 && this.tracks[0].activity_icon) {
            this.sceneActivityIcon = this.tracks[0].activity_icon;            
        }

        await CesiumManagerWrapper.initScene("map3D", {
            users: userData,
            checkContestType: false,
            sceneType: this.scene_type,
            pathsLength: this.path_length,
            isFpvModeByDefault: this.start_in_fpv_mode,
            hostInUse: this.host,
            isTracksAlive: true, // TODO : Update this when we have a way to know if the tracks are alive
            staticLabels: this.localities_around
        });

        this.cesium_started = true;

        setTimeout(function () {
            $("#loading_track_modal").modal("hide");
        }, 500)
    }

    getTrack(track,index) {
        var self = this;
        return new Promise((resolve, reject) => {
            var url = window.application.getAPIUrl() + "/v1/external_track/" + track.id;
            if (track.timestamp_start_at) {
                url += "/timestamp/" + track.timestamp_start_at;
            }

            var ajaxData = {
                url: url,
                method: "GET",
                beforeSend: this.beforeSendHandler,
            };

            $.ajax(ajaxData).done(function (data) {
                self.raw = data;
                var json = data;
                
                // Validate the response data structure
                if (!json || typeof json !== 'object') {
                    console.error("ExternalTrackMap3DHandler: Invalid JSON response", json);
                    reject(new Error("Invalid JSON response"));
                    return;
                }
                
                // Ensure points and points_header are valid arrays, matching TrackMap3DHandler structure
                const validPoints = json.points && Array.isArray(json.points) ? json.points : [];
                const validPointsHeader = json.points_header && Array.isArray(json.points_header) ? json.points_header : [];
                
                // Log warnings for missing data
                if (!json.points || !Array.isArray(json.points)) {
                    console.warn("ExternalTrackMap3DHandler: Missing or invalid points data for track", track.id);
                }
                if (!json.points_header || !Array.isArray(json.points_header)) {
                    console.warn("ExternalTrackMap3DHandler: Missing or invalid points_header for track", track.id);
                }
                
                self.points[index] = { 
                    points: validPoints,
                    points_header: validPointsHeader,
                    other_data: {
                        wind_data: json.wind_data || null
                    }
                };
                resolve();
            }).fail((err) => reject(err));
        });
    }

    isNewPointValid(currentPoint, lastAddedPoint) {
        if (!currentPoint) {
            return false;
        }

        if (lastAddedPoint == null) {
            return true;
        }
        // we need to send only ordered point data
        return currentPoint.tpid > lastAddedPoint.tpid && currentPoint.date > lastAddedPoint.date;
    }

    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    async asyncAddUserToScene(player, hash) {
        const userId = hash.userId;
        const userName = hash.userName;
        
        try {
            await CesiumManager.addUserToScene(hash);
            player.cesium_ready = true;
            console.log(`ExternalTrackMap3DHandler: userName=${userName} successfully added to Cesium`);
        } catch (error) {
            console.error(`ExternalTrackMap3DHandler: Failed to add user userName=${userName}:`, error);
            player.cesium_ready = false;
        }
    }


    getSceneActivityIcon(apiData) {
        if (this.sceneActivityIcon) {
            return this.sceneActivityIcon;
        }
        
        const apiActivityIcon = apiData.category && apiData.category.activity_icon ? apiData.category.activity_icon : null;
        
        if (apiActivityIcon && !this.sceneActivityIcon) {
            this.sceneActivityIcon = apiActivityIcon;        
        }
        
        return apiActivityIcon;
    }

    async addTrackToScene(trackId, userId, userName, apiData) {       
        if (!apiData || !apiData.points || apiData.points.length === 0) {
            console.log(`ExternalTrackMap3DHandler: No points data for userId=${userId}`);
            return;
        }

        // Check if user already exists in players (use userName as the key for consistency)
        if (this.players[userName]) {
            console.log(`ExternalTrackMap3DHandler: userName=${userName} already exists`);
            return;
        }

        console.log(`ExternalTrackMap3DHandler: Adding new user to player userId=${userId} with ${apiData.points.length} points`);

        const points_header = apiData.points_header;
        
        // Convert raw points to the expected format
        const convertedPoints = apiData.points.map(rawPoint => {
            const point = {};
            points_header.forEach((header, index) => {
                point[header] = rawPoint[index];
            });
            return {
                track_point_id: point.track_point_id,
                latitude: point.latitude + "",
                longitude: point.longitude + "",
                speed: point.speed + "",
                altitude: point.altitude,
                computed_altitude: point.altitude,
                moving_type: point.moving_type || "unknown",
                elevation: point.elevation,
                bearing: point.bearing,
                distance: point.distance || 0,
                date: point.date
            };
        });

        const rgbColor = this.hexToRgb(apiData.color);
        const rgbColorArray = [rgbColor.r, rgbColor.g, rgbColor.b];
        const activityIcon = this.getSceneActivityIcon(apiData);

        console.log(`Creating player object for userId=${userId} with trackId=${trackId}`);

        const player = {
            tid: trackId,
            uid: userId,
            uname: userName,
            color: rgbColorArray,
            point_id: convertedPoints.length > 0 ? convertedPoints[convertedPoints.length - 1].track_point_id : 0,
            altitude_offset: 0,
            cesium_ready: false
        };

        this.players[userName] = player;

        // For external tracks added dynamically, align their timeline with the current scene time
        // instead of using their raw timestamps which might be older than existing users
        const currentTime = moment().toISOString().replace("Z", "");
        const started_at = currentTime;

        try {
            // Add user to Cesium with all existing points
            await this.asyncAddUserToScene(player, {
                userId: userId,
                userName: userName,
                track: {
                    id: trackId,
                    color: rgbColorArray,
                    activity_icon: activityIcon,
                    started_at: started_at,
                    created_at: started_at,
                    points: convertedPoints
                }
            });

            console.log(`ExternalTrackLive: Added track for trackId=${trackId} with ${convertedPoints.length} points`);
        } catch (error) {
            console.error(`ExternalTrackMap3DHandler: Failed to add track for userId=${userId}:`, error);
            // Clean up the player if addition failed
            delete this.players[userName];
        }
    }

    onPointReceived(data) {
        if (!this.isNewPointValid(data, this.lastAddedPoints[data.uname])) {
            console.log(`ExternalTrackMap3DHandler: tpid=${data.tpid} for uname=${data.uname} is not valid (duplicate or out of order)`);
            return;
        }

        // Validate that we have the required data
        if (!data.uid || !data.uname || !data.tid) {
            console.error("ExternalTrackMap3DHandler: Invalid point data received", data);
            return;
        }

        // Update last added point immediately to prevent duplicate processing
        this.lastAddedPoints[data.uname] = data;

        const point = {
            track_point_id: data.tpid,
            latitude: data.lat + "",
            longitude: data.lon + "",
            speed: data.speed + "",
            altitude: data.alt,
            computed_altitude: (data.alt),
            moving_type: data.moving_type,
            elevation: data.ele,
            bearing: data.bearing,
            distance: data.dist,
            date: data.date
        }

        if (this.cesium_started == true) {
            var player = this.players[data.uname];

            if (player == null) {
                // User doesn't exist yet, create and add to Cesium
                var rgbColor = this.hexToRgb(data.ucolor);
                var rgbColorArray = [rgbColor.r, rgbColor.g, rgbColor.b];
                
                // Create player using username as key (matching LiveMap3D pattern)
                this.players[data.uname] = {
                    tid: data.tid,
                    uid: data.uid,
                    uname: data.uname,
                    color: rgbColorArray,
                    point_id: 0,
                    altitude_offset: 0,
                    cesium_ready: false
                }

                // Add user to scene asynchronously (only once)
                // Use current time instead of the point's timestamp to avoid timeline conflicts
                const currentTime = moment().toISOString().replace("Z", "");
                this.asyncAddUserToScene(this.players[data.uname], {
                    userId: data.uid,
                    userName: data.uname,
                    track: {
                        id: data.tid,
                        color: rgbColorArray,
                        activity_icon: this.sceneActivityIcon, 
                        started_at: currentTime,
                        created_at: currentTime,
                        points: [point]
                    }
                });

            } else if (player.cesium_ready == true) {
                point.finalized = data.e == "track_end"                
                CesiumManager.addPoint(data.uid, point);
                this.players[data.uname].point_id += 1;
            }
        }
        else {
            if (this.socket_points[data.tid] == null) {
                this.socket_points[data.tid] = [];
            }
            this.socket_points[data.tid].push(point);
        }
    }
}